import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './StringUtils'

Vue.config.productionTip = false;

(window as any).funtoonApp = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
